var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLungs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 76,
    viewBox: "0 0 90 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3555 0.977664C40.9805 0.990164 39.6355 20.8827 39.6305 28.8402C39.6205 38.9952 42.113 59.4927 34.2805 67.2952C26.2955 75.2452 10.338 79.2127 2.36555 72.5752C-5.60695 65.9352 7.74055 0.962664 26.3555 0.977664ZM63.708 1.00766C49.083 0.995164 50.3956 20.8902 50.3881 28.8477C50.3806 39.0052 47.8531 59.4977 55.6756 67.3127C63.6456 75.2777 79.5981 79.2677 87.5806 72.6452C95.5631 66.0202 82.3205 1.02266 63.7056 1.00766H63.708Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLungs);
export default __webpack_public_path__ + "static/media/lungs.7b373a91ba3c744711db3b6ecaffd8f5.svg";
export { ForwardRef as ReactComponent };